import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';
export function VideoShowcase() {
  return <section className="py-12 lg:py-24 relative overflow-hidden" data-id="element-259">
      <div className="container mx-auto px-6" data-id="element-260">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-261">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-262">
            <h2 className="text-brand-accent font-bold tracking-widest uppercase text-sm mb-4" data-id="element-263">
              Operational Excellence
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-264">
              See How We Power <br data-id="element-265" />
              Global Operations
            </h3>
            <p className="text-lg text-slate-400 mb-8 leading-relaxed" data-id="element-266">
              Our teams integrate seamlessly into your workflow, utilizing
              advanced automation and human expertise to drive measurable
              results. Experience the efficiency of a truly scalable operational
              extension.
            </p>
            <div className="flex items-center gap-4 text-white font-bold" data-id="element-267">
              <div className="w-12 h-12 rounded-full bg-brand-accent/20 flex items-center justify-center text-brand-accent" data-id="element-268">
                <PlayCircle className="w-6 h-6" data-id="element-269" />
              </div>
              <span data-id="element-270">Watch our process in action</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative group" data-id="element-271">
            <div className="aspect-video rounded-[2rem] overflow-hidden border border-white/10 shadow-2xl shadow-brand-accent/5" data-id="element-272">
              <video autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-273">
                <source src="https://cdn.magicpatterns.com/uploads/eFi7LDr7wehwWo5oEnyFU4/9150074-sd_960_540_30fps.mp4" type="video/mp4" data-id="element-274" />
              </video>
              <div className="absolute inset-0 bg-brand-dark/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-275" />
            </div>

            {/* Decorative element */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-brand-accent/10 blur-2xl rounded-full" data-id="element-276" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-blue-500/10 blur-3xl rounded-full" data-id="element-277" />
          </motion.div>
        </div>
      </div>
    </section>;
}